<style>
.like {
  border: 1px solid red;
}
.umm {
  border: 2px solid #333;
}
</style>
<template>
  <main id="maching_select_main" class="maching_main">
    <div class="container">
      <ImageSelect
        :quests.sync="question"
        :val.sync="value"
        :selectImg="selectImg"
        :show="show"
        v-bind:build="flg"
      />
      <div class="select_area">
        <div class="content">
          <div class="txt_box">
            <p class="en_txt">Which is your choice?</p>
          </div>
          <LikeBtn
            @updated="updateEvt"
            :quests.sync="question"
            :val.sync="value"
          />
          <HateBtn
            @updated="updateEvt"
            :quests.sync="question"
            :val.sync="value"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import LikeBtn from "@/components/LikeBtn.vue";
import HateBtn from "@/components/HateBtn.vue";
import ImageSelect from "@/components/ImageSelect.vue";
import _ from "lodash";
export default {
  name: "Choice",
  components: {
    ImageSelect,
    LikeBtn,
    HateBtn,
  },
  data: function () {
    return {
      value: 1,
      question: {},
      selectImg: {},
      show: {},
      flg: String,
    };
  },
  props: {
    build: String,
  },
  mounted: function () {
    var q;
    if (this.build == "inner") {
      q = this.$store.getters.innerdata;
    }
    if (this.build == "outer") {
      q = this.$store.getters.outerdata;
    }
    this.question = _.shuffle(q);
    this.flg = this.build;
  },
  methods: {
    updateEvt(val, question, selectImg, show) {
      this.value = val;
      this.question = question;
      this.selectImg = selectImg;
      this.show = show;
    },
  },
  watch: {
    value: function (val) {
      if (val == 21) {
        this.$router.push("/result/" + this.build);
      }
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
